import React from 'react';
import { prefixClass } from 'lib/utils';
import AuditAlert from '../AuditAlert';

import './TransactionsTableFooter.scss';
import { useTransactionsTableContext } from '../../Chart/context/TransactionsTableContext';
import classNames from 'classnames';
import { useNTContext } from 'presentation/components/NewTable/NTContext';

const TransactionsTableTableFooter: React.FC = () => {
  const context = useTransactionsTableContext();
  const { total, balance, reportType, selectedTransaction } = context;
  const cellId = selectedTransaction?.cellID.split('_').pop() || '';
  const accountId = selectedTransaction?.id.split('_')[0] || '';
  const prefix = prefixClass('transactions-table-footer');
  const auditResultStateShown = ['warning', 'error', 'fail', 'dismissed'];

  // @ts-ignore
  const auditResult = selectedTransaction?.auditResult;
  const showAuditAlert = auditResult && auditResultStateShown.includes(auditResult.type?.toLowerCase());

  const { dismissedAudit } = useNTContext();

  const getLeftCellClass = () => {
    const isDismissedLocally = dismissedAudit.some(
      da => da.rowIndex === Number(accountId) && da.isDismissed === true && da.columnIndex === Number(cellId)
    );

    const baseClass = classNames(prefix('row-cell-left'), {
      ['dismissed']: auditResult.type === 'Dismissed' || isDismissedLocally,
    });
    if (!showAuditAlert) return baseClass;

    const type = auditResult?.type?.toLowerCase();
    if (type === 'error' || type === 'fail') {
      return `${baseClass} ${prefix('row-cell-left--error')}`;
    }
    return baseClass;
  };

  return (
    <div className={prefix()}>
      <div className={prefix('row')}>
        {showAuditAlert && (
          <div className={getLeftCellClass()}>
            <AuditAlert
              cellId={cellId}
              auditResult={auditResult}
              accountId={accountId}
              className={prefix('vendor-anomaly')}
              iconClassName={classNames(prefix('vendor-anomaly-icon'), {
                dismissed: auditResult.type === 'Dismissed',
              })}
              textClassName={prefix('vendor-anomaly-text')}
              titleIconClassName={prefix('vendor-anomaly-title-icon')}
              titleClassName={prefix('vendor-anomaly-title')}
              messageClassName={prefix('vendor-anomaly-message')}
              buttonClassName={prefix('vendor-anomaly-button')}
            />
          </div>
        )}
        <div className={showAuditAlert ? prefix('row-cell-right') : prefix('row-cell-full')}>
          <div className={prefix('totals-section')}>
            <span className={prefix('total-label')}>TOTAL</span>
            <span className={prefix('total-amount')}>
              {total.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
            </span>
            {reportType === 'AP Aging' && (
              <span className={prefix('balance-amount')}>
                {balance.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionsTableTableFooter;
